import { createSlice } from '@reduxjs/toolkit'
import { register } from '../components/helpers/reducerRegistry'
import { localStorageKeys } from '../components/utils/common'
import { DEFAULT_TYPE_FONT_SIZE } from '../configs/fontSize'
import { DEFAULT_THEME } from '../configs/theme'
import { defaultTimeZone } from '../configs/timeZone'

const slice = createSlice({
  name: 'app',
  initialState: {
    theme: DEFAULT_THEME,
    typeFontSize:
      localStorage.getItem(localStorageKeys.KEY_FONT_SIZE) ||
      DEFAULT_TYPE_FONT_SIZE,
    timeZone: defaultTimeZone.offset,
  },
  reducers: {
    changeTypeFontSize: (state, action) => {
      localStorage.setItem(localStorageKeys.KEY_FONT_SIZE, action.payload)
      state.typeFontSize = action.payload
    },
    changeTheme: (state, action) => {
      state.theme = action.payload
    },
  },
})

export const { changeTheme, changeTypeFontSize } = slice.actions
export const selectTheme = (state) => state[slice.name].theme
export const selectTypeFontSize = (state) => state[slice.name].typeFontSize
export const selectTimeZone = (state) => state[slice.name].timeZone

register(slice.name, slice.reducer)
